import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

import { Observable, of } from 'rxjs';
import { Service } from './service.model';
import { Image } from '@data/models/image.model';
import { servicesData } from './data/services.data';

@Injectable({
  providedIn: 'root',
})
export class ServicesService {
  constructor() { }

  getImages(): Observable<string[]> {
    // const images = servicesData.map((service) => service.images);
    // return of([].concat(...images));
    const images = [
      'https://media.gill-photography.com.au/services/services-0.jpg',
      'https://media.gill-photography.com.au/services/services-1.jpg',
      'https://media.gill-photography.com.au/services/services-2.jpg',
      'https://media.gill-photography.com.au/services/services-3.jpg',
      'https://media.gill-photography.com.au/services/services-4.jpg',
    ]
    return of(images);
  }

  getAll() {
    return servicesData;
  }

  getSingle(id: string): Observable<Service> {
    const services = servicesData.find((service) => service.id === id);

    return of(services);
  }
}
